import React, { useState } from 'react';
import {openModal} from 'state/modals/actions';
import {trackClick} from 'utility/analytics';
import numeral from 'numeral'
import { LG, MD, SM  } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { Button } from 'theme/Button';
import { filter, map, startCase, pick, get } from 'lodash';
import ImageGallery from 'components/ImageGallery/ImageGallery';
import { AttributeRow, LeftColumn, RightColumn, Attribute, AttributeWrapper, ImageGalleryWrapper, AttributesCol, Wrapper, OrWrapper } from './ListingsHero.styles.js';



function generateAttributes(data = {}) {
  const attributes = pick(data, ['listing_type','listing_brand', 'listing_model', 'listing_style', 'listing_part_number']);
  if (get(data, 'attributes.mill_year')) {
    attributes.mill_year = data.attributes.mill_year
  }
  if (get(data, 'attributes.manufacturer')) {
    attributes.manufacturer = data.attributes.manufacturer
  }

  return filter(map(attributes, (value, key) => {
    const formatted = key === 'price' ? `${value} ${data.quantity_uom_name}` : value;
    return {
      title: startCase(key.replace('listing_', '').replace('style', 'Equipment')),
      value: formatted
    }
  }), ({value}) => !!value)
}


const ListingsHero = ({productDetails, userId, onInquire}) => {
  const title =  productDetails.listing_name;
  const description = productDetails.listing_description || '';
  const location = productDetails.location_description || '';
  let images = productDetails.images || (productDetails.image ? [{image: productDetails.image}] : []);
  if (get(productDetails, 'listing_data.images.length')) {
    images = [...images, ...(map(get(productDetails, 'listing_data.images'), (m) => ({image: m})))]
  }
  const attributes = generateAttributes(productDetails);
  return (
    <Wrapper>
      <Grid>
        <Row>
          <Col>
            <LG bold style={{lineHeight: '40px', fontSize: '30px'}} as="h1">Reconditioned {title}</LG>
          </Col>
        </Row>
        <Row justifyContent="between">
          <Left images={images} location={location} description={description} title={title} attributes={attributes}/>
          <Right userId={userId} onInquire={onInquire} productDetails={productDetails} description={description} />
          <Col className="title-description">
            <SM paddingTopXl bold className="title-description"  style={{fontSize: '14px', marginBottom: 0}} noMargin as="h3">Description: </SM>
            <SM className="title-description" grey style={{fontSize: '14px'}} noMargin as="h3">{description}</SM>
          </Col>
        </Row>
      </Grid>
    </Wrapper>
  )
}


const Left = ({attributes, title, description, location, images} = {}) => {
  return (
    <LeftColumn>
      <Flex wrap="wrap">
        <ImageGalleryWrapper>
          <ImageGallery keyDownEvents={true} images={images} />
        </ImageGalleryWrapper>
        <AttributesCol>
          <HeroAttributes location={location} description={description} attributes={attributes}/>
        </AttributesCol>
      </Flex>
    </LeftColumn>
  )
}



const Right = ({description, productDetails = {}, userId}) => {
  
  function inquire() {
    trackClick('inquireProduct', 'Inquire', 'Listing');
    openModal({
      type: 'inquireFormModal',
      data: {
        productDetails
      }
    })
  }

  return (
    <RightColumn SM={12} size={12} md={'100%'}>
      <Flex column>
        <Flex justifyBetween alignCenter>
          <SM tag="h2" bold>Availability</SM>
          <MD onClick={inquire} noMargin tag="h2" style={{fontSize: '13px'}} grey>Inquire</MD>
        </Flex> 

        <Flex justifyBetween alignCenter>
          <SM tag="h2"paddingTopMd bold>MRT Price</SM>
          {
            productDetails.price ?
            <MD paddingTopMd noMargin bold tag="h2" scaled>${numeral(productDetails.price).format('0,0.00')} <MD noMargin grey style={{fontSize: '11px'}} tag="span"> / {productDetails.price_uom_name}.</MD></MD> :
            <MD grey paddingTopMd noMargin tag="h2" style={{fontSize: '13px'}}>Available With Quote</MD>
          }
        </Flex> 

        <div><Button onClick={inquire} style={{width: '100%', maxWidth: '100%', fontSize: '16px'}} size="large" spacingTop primary bold>Get Availability & Pricing</Button></div>
        <OrWrapper><SM tag="h3" paddingTopMd center slate>OR</SM></OrWrapper>
        <SM tag="h4" paddingTopMd center slate>Give Us A Call: <a href="tel:440-942-2922">440.942.2922</a></SM>
        
      </Flex>
    </RightColumn>
  )
}


const HeroAttributes = ({description, attributes, location} = {}) => {
  const defaultClamp = 324;
  const [clamp, setClamp] = useState(defaultClamp);
  const isClamp = description.length > clamp;
  const descriptionTrunc = isClamp ? `${description.substring(0, clamp)}...` : description;

  return (
    <div>
      <AttributeRow description={!!description}>
        {
          map(attributes, (attribute, i) => {
            return (
              <AttributeWrapper size={i%2 === 0 ? "3" : "3"} key={i}>
                <Attribute>
                  <SM style={{fontSize: '16px'}} noMargin as="h3" bold>{attribute.title}</SM>
                  <SM style={{fontSize: '14px'}} noMargin as="h3">{attribute.value}</SM>
                </Attribute>
              </AttributeWrapper>
            )
          })
        }
      </AttributeRow>
      {
        location ? 
        <AttributeRow>
          <AttributeWrapper>
            <Attribute>
              <SM style={{fontSize: '16px'}} noMargin as="h3" bold>Location</SM>
              <SM style={{fontSize: '14px'}} noMargin as="h3">{location}</SM>
            </Attribute>
          </AttributeWrapper>
        </AttributeRow>: null
      }
      <Attribute className="attribute-description">
        <SM style={{fontSize: '16px'}} noMargin as="h3" bold>Description</SM>
        <SM grey style={{fontSize: '14px', 'whiteSpace': 'pre-wrap'}} noMargin as="h3">{descriptionTrunc} {description.length <= defaultClamp ? null : isClamp ? <SM grey onClick={() => setClamp(1000000)} style={{fontSize: '14px'}} noMargin as="span" link>Read More</SM> : <SM grey onClick={() => setClamp(defaultClamp)} style={{fontSize: '14px'}} noMargin as="span" link>Read Less</SM>}</SM>
      </Attribute>
    </div>
  )
}

export default ListingsHero;
